import { createFileRoute } from '@tanstack/react-router'

import { PlatformGuaranteesTablesPage } from '../../../components/pages/backoffice/platform/platform-guarantees-tables-page/platform-guarantees-tables-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/guarantees-tables')({
  component: () => (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <PlatformGuaranteesTablesPage />
    </PermissionChecker>
  ),
})
